import React from 'react';
import ReactEcharts from 'echarts-for-react';

// render echarts option.

const BarChart = ({ question, crowdAverage }) => {

	let otherAnswers = [...question.otherAnswers];


	const option = {
		color: ['#a79d96'],
		/*
		title: {
			subtext: 'Fördelning av samtliga svar på denna fråga.',
			top: 'bottom',
			left: 'center'
		},*/
		tooltip: {
			axisPointer: {
				type: 'shadow'
			},
			formatter: function (params) {
				var id = params.dataIndex;

				let percent = (otherAnswers[id] / crowdAverage.amount) * 100;

				return otherAnswers[id] + ' personer (' + percent.toFixed(1) + ' %)';
			}
		},
		datazoom: {
			type: 'bar'
		},
		yAxis: {
			type: 'category',
			data: [...question.otherAnswers.keys()].reverse(),
			splitLine: {
				show: true
			}
		},
		xAxis: {
			type: ['value'],
			splitLine: {
				show: true
			}/*,
			axisLabel: {
				formatter: '{value} personer'
			}*/
		},
		series: [{
			data: otherAnswers.reverse(),
			type: 'bar',
			itemStyle: {
				normal: {
					color: function (params) {
						var index = params.dataIndex;

						if (parseInt(params.name) === question.chosenAnswerIndex) {
							return '#00aaef';
						} else {
							return '#a79d96';
						}
					}
				}
			},
		}],
	};
	return <div>
		<ReactEcharts option={option} />
		<p style={{ color: 'grey', textAlign: 'center', fontSize: '0.8em', marginTop: '-1em' }}>Fördelning av samtliga svar på denna fråga.</p>
	</div>;
}

export default BarChart;



// WEBPACK FOOTER //
// ./src/components/BarChart.js